import { Component, EventEmitter, Input, OnInit, Output, signal } from '@angular/core';
import { DisplayType } from '@models/module/fields/enums';
import { AddressModel } from '@models/module/fields/main';
import { CipoAddressConfig, CipoAddressControl, CipoFieldTypes } from '../common';
import { CipoAddressComponent } from './cipo-address.component';

@Component({
  selector: 'cipo-address-angularjs',
  imports: [CipoAddressComponent],
  template: `<cipo-address
    [(fieldData)]="fieldData"
    [control]="control()"
    [angularJsSupport]="true"
    [angularJsSupportCellField]="cellfield"
  ></cipo-address>`,
})
export class CipoAddressAngularJsComponent implements OnInit {
  @Input() label: string;
  @Input() readonly: boolean;
  @Input() multiple: boolean;
  @Input() required: boolean;
  @Input() disabled: boolean;
  @Input() cellfield: boolean;
  /** Address visualization mode — see `DisplayType.Address/AddressLocationName/AddressOnly`. */
  @Input('displaytype') displayType: DisplayType;

  /** Check the validity of the control */
  @Input('checkvalidity') set checkValidity(_: boolean) {
    this.control()?.markAsTouched();
    this.control()?.updateValueAndValidity();
  }

  @Input() value: AddressModel | AddressModel[];
  @Output() valueChange = new EventEmitter<AddressModel | AddressModel[]>();

  fieldData = signal<CipoAddressConfig>({});
  control = signal<CipoAddressControl>(null);

  ngOnInit() {
    this.fieldData.set({
      type: CipoFieldTypes.Address,
      label: this.label,
      readonly: this.readonly ?? false,
      multiple: this.multiple ?? false,
      required: this.required ?? false,
      ...(this.displayType && { displayType: this.displayType }),
    });

    // remove null values inside array when multiple is true, to avoid issues with Angular Material form field validation
    if (this.multiple && Array.isArray(this.value)) {
      this.value = this.value.filter(v => !!v);
    }
    
    this.control.set(new CipoAddressControl(this.value, this.fieldData()));
    if (this.disabled) {
      this.control().disable();
    }
    this.control().valueChanges.subscribe(val => {
      this.valueChange.emit(val);
    });
  }
}
